<script>
    import { link } from "svelte-routing";
    export let id;
    export let street;
    export let housenumber;
    export let title_img;

    let random = Math.random()*360;
</script>

<a use:link href="/orte/{id}" class="thumbnail">
<!-- <a href="/orte/{id}" class="thumbnail" style="background-image: url(/images/orte/original/{title_img}); background-color: hsl({random}, 20%, 20%)"> -->
    <div class="img-wrapper" style="background-image: url(/images/orte/title_preview/{title_img})"></div>
    <div class="overlay"></div>
    <span class="name">{street??"Unbenannt"} {housenumber??""}</span>
</a>

<style>
    .thumbnail {
        display: block;
        width: 100%;
        box-sizing: border-box;
        padding-top: 60%;
        color: white;
        position: relative;
        text-align: center;
        border-radius: 0.6rem;
        overflow: hidden;
    }

    .img-wrapper {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
    }

    .name {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 1rem;
        background: rgb(0,0,0);
        /* background: linear-gradient(180deg, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 100%); */
        background: linear-gradient(0, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 100%);
    }

    .more {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        padding: 1rem;
        background: rgb(0,0,0);
        background: linear-gradient(0, rgba(0,0,0,0.3) 0%, rgba(0,0,0,0) 100%);
        opacity: 0.5;
        font-size: 0.8rem;
    }

    .overlay {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
        background: rgb(0,0,0);
        background: linear-gradient(0, rgba(0,0,0,0.8) 0%, rgba(0,0,0,0) 100%);
    }
</style>